import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useNavigate, useLocation } from "react-router-dom";
import { FaCheckCircle, FaBoxOpen, FaHome } from "react-icons/fa";
import Confetti from "react-confetti";
import "./orderSuccess.css";
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";

const OrderSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // ✅ fallback from localStorage
  const savedOrder = JSON.parse(localStorage.getItem("lastOrder"));

  const { orderNumber, total } = location.state || savedOrder || {};

  const [timeLeft, setTimeLeft] = useState(10);

  // ⏳ countdown
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          navigate("/");
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div>
      <Header />
      <div className="success-page">
        <Confetti numberOfPieces={200} />

        <motion.div
          className="success-card"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          {/* ✅ Animated Tick */}
          <motion.div
            className="success-icon"
            initial={{ scale: 0 }}
            animate={{ scale: [0, 1.2, 1] }}
            transition={{ duration: 0.6 }}
          >
            <FaCheckCircle />
          </motion.div>

          <motion.h2
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
          >
            Order Placed Successfully!
          </motion.h2>

          <p className="success-subtext">Thank you for your purchase 🎉</p>

          {/* Order Info */}
          <div className="order-details">
            <p>
              <strong>Order Number:</strong> {orderNumber || "N/A"}
            </p>
            <p>
              <strong>Total Paid:</strong> ₹{total || 0}
            </p>
          </div>

          {/* Buttons */}
          <div className="success-actions">
            <button
              className="track-btn"
              onClick={() => navigate(`/track/${orderNumber}`)}
            >
              <FaBoxOpen /> Track Order
            </button>

            <button className="home-btn" onClick={() => navigate("/")}>
              <FaHome /> Continue Shopping
            </button>
          </div>

          {/* ⏳ Countdown */}
          <p className="redirect-text">
            Redirecting to home in {timeLeft} seconds...
          </p>
        </motion.div>
      </div>
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default OrderSuccess;
